import { combineReducers } from "redux";

const userdata = (state = {}, action) => {
  switch (action.type) {
    case "SET_SESSION_DATA":
      return action.userdata;
    case "CLEAR_SESSION_DATA":
      return {};
    default:
      return state;
  }
};

const userId = (state = null, action) => {
  switch (action.type) {
    case "SET_SESSION_DATA":
      if (!action.userdata.user_id) {
        return null;
      }
      return action.userdata.user_id;
    default:
      return state;
  }
};

const isLoginRequired = (state = false, action) => {
  switch (action.type) {
    case "SET_LOGIN_REQUIREMENT":
      return action.require_login;
    default:
      return state;
  }
};

const expiresIn = (state = false, action) => {
  switch (action.type) {
    case "SET_SESSION_EXPIRES":
      return action.sessionExpiresIn;
    case "SET_SESSION_EXPIRED":
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  userdata,
  userId,
  isLoginRequired,
  expiresIn,
});

export const getIsLoggedIn = (state) =>
  !!state.userId && state?.userdata?.verified;
export const getIsLoginRequired = (state) => !!state.isLoginRequired;
export const getIsAccountVerified = (state) =>
  getIsLoggedIn(state) && state.userdata.active === "1";
export const getSessionUserId = (state) => state.userId;
export const getSessionUserdata = (state) => state.userdata;
export const getSessionRoles = (state) =>
  state.userdata && Array.isArray(state.userdata.roles)
    ? state.userdata.roles
    : [];
export const getSessionHasRole = (state, role) =>
  getSessionRoles(state).indexOf(role) > -1;
export const getSessionHasRoles = (state, roles) => {
  const sessionRoles = getSessionRoles(state);

  if (
    !Array.isArray(sessionRoles) ||
    sessionRoles.length === 0 ||
    !Array.isArray(roles) ||
    roles.length === 0
  ) {
    return false;
  }
  const result =
    roles.filter((role) => sessionRoles.indexOf(role) > -1).length > 0;

  return result;
};
export const getIsSSOAccount = (state) =>
  getIsLoggedIn(state) && state.userdata.is_sso_user;
